import axios, { AxiosInstance } from "axios";
import StorageService from "../services/StorageService";
import { API_URL } from "../utils/setting";

const axiosAuth = axios.create({
  baseURL: API_URL,
});

createCheckLoginInterceptor(axiosAuth);
createConfigInterceptor(axiosAuth);

function createConfigInterceptor(ins: AxiosInstance) {
  ins.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem("tokenRESHARE");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      throw error;
    }
  );
}

function createCheckLoginInterceptor(ins: AxiosInstance) {
  ins.interceptors.response.use(async (response) => {
    if (response.data.code === 401) {
      StorageService.profile = undefined;
      StorageService.token = "";
    }
    return response;
  });
}

export default axiosAuth;
